import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

const CENTRODECUSTOS_URL = `${API_URL}/centrodecustos/`;

export async function getCentroDeCustos(alias, page, token) {
    const CentroDeCustosUrl = `${CENTRODECUSTOS_URL}${alias}?page=${page}`;
    const headers = { 'authorization': token }

    console.log(CentroDeCustosUrl);
    const response = await axios.get(CentroDeCustosUrl, { headers });
    return response.data;
}

export async function getCentroDeCusto(id, token) {
    const CentroDeCustosUrl = `${CENTRODECUSTOS_URL}id/${id}`;
    const headers = { 'authorization': token }

    console.log(CentroDeCustosUrl);
    const response = await axios.get(CentroDeCustosUrl, { headers });
    return response.data;
}


export async function getAllCentroDeCustos(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${CENTRODECUSTOS_URL}all`, { headers });
    return response.data;
}

export async function getActiveCentroDeCustos(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${CENTRODECUSTOS_URL}active`, { headers });
    return response.data;
}


export async function saveCentroDeCusto(id, newCentroDeCusto, token) {
    const headers = { 'authorization': token };
    let response;
    if (id)
        response = await axios.patch(`${CENTRODECUSTOS_URL}${id}`, newCentroDeCusto, { headers });
    else
        response = await axios.post(CENTRODECUSTOS_URL, newCentroDeCusto, { headers });
    return response.data;
}
